import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f0fc47e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " *아래 사항을 모두 확인하고 순서대로 클릭해 주세요. ", -1))
const _hoisted_2 = { class: "box-options" }
const _hoisted_3 = { class: "footer-btn-group" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
    /*#__PURE__*/_createTextVNode(" 제로 웨이스트 박스는 "),
    /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
    /*#__PURE__*/_createTextVNode(" 종량제 쓰레기 봉투 75리터 크기예요. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
    /*#__PURE__*/_createTextVNode(" 참여 유형은 신청 후 "),
    /*#__PURE__*/_createElementVNode("strong", null, "변경이 불가능"),
    /*#__PURE__*/_createTextVNode("하니 "),
    /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
    /*#__PURE__*/_createTextVNode(" 신중하게 선택해 주세요. ")
  ])
], -1))
const _hoisted_6 = { class: "group-type" }
const _hoisted_7 = { class: "group-type-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "footer-btn-group" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["onSubmit"]
const _hoisted_12 = { class: "form-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("소속 명"),
  /*#__PURE__*/_createElementVNode("small", null, "(가족 닉네임, 직장명, 학교 이름 등)")
], -1))
const _hoisted_14 = { class: "form-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "참여 인원", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  style: {"position":"fixed","left":"-200%"}
}, null, -1))
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 원더플 피플로 선정된 분들께는 ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }, null, -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("에")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 개별 카카오 알림톡을 보내드려요 ")
const _hoisted_24 = { class: "footer-btn-group" }
const _hoisted_25 = { class: "footer-btn-group" }

import Popup from './popup.vue';
import PopupError from './popup-error.vue';
import { type DeepReadonly, type Ref, computed, nextTick, reactive, ref, inject } from 'vue';
import _ from 'lodash';
import Options from './options.vue';
import { request } from '@/utils';
import { IProgram } from '@/types/program';
import { useFocus } from '@vueuse/core';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

export interface ParticipateExpose {
  start: () => Promise<void>;
}

interface FormType {
  collection_challenge?: 2 | 4;
  people_collection?: 'individual' | 'group_type';
  group_name?: string;
  collecting_people_number?: number;
  organization_type?: string;
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

dayjs.extend(isBetween);

const popupVisible = reactive({
  step1: false,
  step2: false,
  step3: false,
  success: false,
  error: false,
});

function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    _.forEach(popupVisible, (val, key) => {
      if (val) {
        popupVisible[key] = false;
      }
    });
  }
}

async function showPopup(key: keyof typeof popupVisible) {
  hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

const form = ref<FormType>({});

const program = inject<DeepReadonly<Ref<IProgram>>>('program');
const refreshPageData = inject<Function>('refreshPageData') || _.noop;

const currentParticipateRound = computed(() => {
  return program?.value.program_rounds?.find(item => dayjs().isBetween(item.participate_started_at, item.participate_ended_at));
});

const DAY_OF_WEEK_MAP = {
  0: '일요일',
  1: '월요일',
  2: '화요일',
  3: '수요일',
  4: '목요일',
  5: '금요일',
  6: '토요일'
};

// 两天后公布
const announcedOn = computed(() => {
  if (currentParticipateRound.value) {
    const $time = dayjs(currentParticipateRound.value.participate_ended_at).add(2, 'day');
    return {
      month: $time.month(),
      date: $time.date(),
      dayOfWeek: $time.day(),
    };
  }
  return null;
});

const step1Options = [
  '당첨자 선정은 100% 기계식 추첨으로 진행돼요.',
  '45일 내에 N개 박스 모두 수거 신청해야 <br>리워드를 받을 수 있어요.',
  '올바른 분리배출 방법이나 수거품목을 지키지 <br>않으면 리워드를 받을 수 없어요',
  '투명 음료 페트병만 수거 가능하니 페이지 하단의 <br>수거 가이드를 꼭 확인해 주세요.',
];
const step1OptionSelected = ref([]);
const step1OptionAllChecked = computed(() => step1OptionSelected.value.length === step1Options.length);

const step2FormData: {
  label: string;
  type: FormType['people_collection'];
  collection_challenge: FormType['collection_challenge'];
}[] = [
  {
    label: '개인',
    type: 'individual',
    collection_challenge: 2,
  },
  {
    label: '가족',
    type: 'group_type',
    collection_challenge: 2,
  },
  {
    label: '직장',
    type: 'group_type',
    collection_challenge: 4,
  },
  {
    label: '학교',
    type: 'group_type',
    collection_challenge: 4,
  },
  {
    label: '식당&카페',
    type: 'group_type',
    collection_challenge: 4,
  }
];
const step2FormDataGroupByCollectionChallenge = _.groupBy(step2FormData, 'collection_challenge');
const collectionChallengeLabelMap = {
  2: '2박스',
  4: '4박스'
};
function onGroupTypeClick(item: typeof step2FormData[number]) {
  Object.assign(form.value, {
    people_collection: item.type,
    organization_type: item.label,
    collection_challenge: item.collection_challenge
  });
}

const errMsg = ref('');
async function onSubmit() {
  try {
    await request.post(`programs/${program?.value.id}/participate`, form.value, { loading: { silent: true } });
    await refreshPageData();
    showPopup('success');
  } catch (e) {
    hidePopup();
    const status = _.get(e, 'status');
    const errorMsg = _.get(e, 'message');
    const code = _.get(e, 'code');
    // request.ts已经处理过这个code了
    if (status !== 401 && String(code) !== '40305') {
      errMsg.value = errorMsg;
      showPopup('error');
    }
    throw e;
  }
}

const formRef = ref<HTMLFormElement>();
async function onStep3Submit() {
  const result = formRef.value?.reportValidity();
  if (!result) {
    return;
  }
  onSubmit();
}

async function start() {
  // 清空选择
  step1OptionSelected.value = [];
  form.value = {};
  showPopup('step1');
}

const groupNameInputRef = ref<HTMLInputElement>();
const { focused: groupNameInputFocused } = useFocus(groupNameInputRef);
async function onStep2Submit() {
  // group类型才需要走到下一步
  if (form.value.people_collection === 'group_type') {
    showPopup('step3');
    await nextTick();
    groupNameInputFocused.value = true;
  } else {
    // 个人的直接参加
    onSubmit();
  }
}

expose({
  start,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step1,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).step1) = $event)),
      title: "참여 신청 기회를 획득했어요!<br>계속해서 캠페인 지원을 완료해 주세요!",
      class: "participate-modal step-1"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "footer-btn primary",
            disabled: !_unref(step1OptionAllChecked),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPopup('step2')))
          }, " 캠페인 지원하러 가기 ", 8, _hoisted_4)
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Options, {
            modelValue: step1OptionSelected.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((step1OptionSelected).value = $event)),
            options: step1Options
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step2,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(popupVisible).step2) = $event)),
      title: "도전할 챌린지 유형을 <br class=\"d-block d-md-none\">선택해 주세요.",
      class: "participate-modal step-2"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "footer-btn primary",
            disabled: !form.value.collection_challenge,
            onClick: onStep2Submit
          }, " 캠페인 지원하러 가기 ", 8, _hoisted_10)
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(step2FormDataGroupByCollectionChallenge), (data, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "box-group-type"
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(collectionChallengeLabelMap[key]), 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: _normalizeClass(["item", { active: item.label === form.value.organization_type }]),
                  onClick: ($event: any) => (onGroupTypeClick(item))
                }, _toDisplayString(item.label), 11, _hoisted_8))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step3,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(popupVisible).step3) = $event)),
      title: "함께하는 원더플 피플은 <br class=\"d-block d-md-none\">누구인가요?",
      class: "participate-modal step-3"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", { class: "footer-btn-group" }, [
          _createElementVNode("button", {
            class: "footer-btn primary",
            onClick: onStep3Submit
          }, " 다음으로 이동 ")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", {
          ref_key: "formRef",
          ref: formRef,
          onSubmit: _withModifiers(onStep3Submit, ["stop","prevent"])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              ref_key: "groupNameInputRef",
              ref: groupNameInputRef,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.group_name) = $event)),
              type: "text",
              placeholder: "테라사이클 코리아 팀",
              required: ""
            }, null, 512), [
              [_vModelText, form.value.group_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.collecting_people_number) = $event)),
              type: "number",
              placeholder: "5",
              required: "",
              enterkeyhint: "done",
              min: "1"
            }, null, 512), [
              [_vModelText, form.value.collecting_people_number]
            ])
          ]),
          _hoisted_16
        ], 40, _hoisted_11)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).success,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(popupVisible).success) = $event)),
      title: "지원 완료!!",
      class: "step-success",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "footer-btn primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (hidePopup()))
          }, " 완료 ")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _hoisted_19,
          (_unref(announcedOn))
            ? (_openBlock(), _createElementBlock("strong", _hoisted_20, _toDisplayString(_unref(announcedOn).month + 1) + "월 " + _toDisplayString(_unref(announcedOn).date) + "일 " + _toDisplayString(DAY_OF_WEEK_MAP[_unref(announcedOn).dayOfWeek]) + " 오전 11시", 1))
            : _createCommentVNode("", true),
          _hoisted_21,
          _hoisted_22,
          _hoisted_23
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).error,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(popupVisible).error) = $event)),
      title: errMsg.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (hidePopup()))
          }, " 확인했어요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})